export default __webpack_public_path__ + "static/media/logo.6d1b0292.png";